import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import {
  SearchResult,
  buildPaginacaoParams,
} from '@/app/core/service/table.service'
import { environment } from '@environment/environment'
import { ListaTableQuery, } from '../models/lista.model'
import { ListaDetailsDto } from '../models/lista-details.model'
import { ListaRegistrarDto } from '../models/lista-registrar.model'
import { ListaAtualizarDto } from '../models/lista-atualizar.model'

export type { ListaTableQuery }

@Injectable({
  providedIn: 'root',
})
export class ListaService {
  private readonly apiUrl = `${environment.basePath}/listas`

  private http = inject(HttpClient)

  listarPaginado(query: ListaTableQuery): Observable<SearchResult<ListaDetailsDto>> {
    const params = buildPaginacaoParams(query)

    return this.http.get<SearchResult<ListaDetailsDto>>(this.apiUrl, { params })
  }

  obterPorId(id: number): Observable<ListaDetailsDto> {
    return this.http.get<ListaDetailsDto>(`${this.apiUrl}/${id}`)
  }

  obterExterna(): Observable<ListaDetailsDto> {
    return this.http.get<ListaDetailsDto>(`${this.apiUrl}/externa`)
  }

  cadastrar(payload: ListaRegistrarDto): Observable<void> {
    return this.http.post<void>(this.apiUrl, payload)
  }

  atualizar(id: number, payload: ListaAtualizarDto): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${id}`, payload)
  }

  excluir(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`)
  }
}